// extracted by mini-css-extract-plugin
module.exports = {"custom-url":"custom-url--1Pa_-23xV7","customUrl":"custom-url--1Pa_-23xV7"};